import { FieldsService } from "smck-service";
import ReservationService from "@/service/reservation-service";
import CompanyService from "@/service/company-service";
import find from "lodash/find";
import { FlashMessageService } from "zoox-infra";
import Vue from "vue";
import uuid from "uuid";
import { mapActions, mapState } from "vuex";
import { zLanguageChanger } from "zoox-components";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import MobileSteps from "@/components/shared/MobileSteps";
import GuestDocuments from "@/components/shared/GuestDocuments";
import FNRHService from "@/service/fnrh-service";

export default {
  name: "DocScan",
  mixins: [sessionMixin],
  components: {
    MobileSteps,
    GuestDocuments,
    "z-language-changer": zLanguageChanger
  },
  data() {
    return {
      activeTab: 0,
      isActive: false,
      currentCompany: {},
      customizationSettings: {},
      enableRecognition: true,
      enableZooxpay: false,
      reservationService: new ReservationService(),
      companyService: new CompanyService(),
      fieldsService: new FieldsService(Vue),
      FNRHService: new FNRHService(),
      fieldSettingsData: { isEmpty: true },
      chargeToPayAtCheckin: null,
      tabHistory: [],
      enabledScanTab: false,
      emailNotRequired: false,
      jobNotRequired: false,
      isMaster: false,
      orientationTexts: null
    };
  },
  computed: Object.assign({}, mapState(["currentReservation"])),
  watch: {
    currentReservation: function(data) {
      if (
        data &&
        data.guests &&
        this.$route.params &&
        this.$route.params.guestId
      ) {
        const currentGuest = find(data.guests, item => {
          return item.id === this.$route.params.guestId;
        });

        this.isMaster = currentGuest.masterGuest || false;
      }
    }
  },
  created() {
    const $context = this;
    $context.currentCompany = $context.companyService.getLocalCompany();

    if ($context.currentCompany && $context.currentCompany.parameters_sc) {
      this.orientationTexts =
        $context.currentCompany.parameters_sc.orientationTexts;
    }
  },
  mounted() {
    if (this.$route.params.reservationId && this.$route.params.guestId) {
      this.getReservation(
        this.$route.params.reservationId,
        this.$route.params.guestId
      );
    } else {
      FlashMessageService.warning(
        this.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
      );
      this.$redirectSearch();
    }
    const $context = this;
    $context.currentCompany = $context.companyService.getLocalCompany();
    $context.customizationSettings = $context.companyService.getLocalCustomizationSettings();
    $context.enabledScanTab =
      $context.$customization && $context.$customization.enableDocumentScan;

    if (
      $context.currentCompany &&
      $context.currentCompany.parameters_sc &&
      $context.currentCompany.parameters_sc.globalSettings
    ) {
      $context.enableRecognition =
        $context.currentCompany.parameters_sc.globalSettings
          .enableRecognition !== false;
      $context.enableZooxpay =
        $context.currentCompany.parameters_sc.globalSettings.enableZooxpay;
    }

    $context.fieldsService
      .getFormattedFields($context.currentCompany.id)
      .then(resp => {
        $context.fieldSettingsData = resp;
      });

    Vue.$globalEvent.$on("tabChange", index => {
      $context.onTabChanged(index);
    });

    Vue.$globalEvent.$on("requiredEmail", value => {
      this.emailNotRequired = value;
    });
    Vue.$globalEvent.$on("requiredJob", value => {
      this.jobNotRequired = value;
    });

    if (process.env.NODE_ENV !== "development") {
      window.onbeforeunload = function() {
        return $context.$t("GLOBAL.PREVENT_RELOAD");
      };
    }
  },
  destroyed() {
    window.onbeforeunload = null;
  },
  methods: Object.assign(
    {
      getReservation: function(reservationId) {
        this.reservationService
          .getOne(reservationId)
          .then(async res => {
            const currentGuest = res.guests.find(
              g => g.id === this.$route.params.guestId
            );

            this.$setCurrentGuest(currentGuest);
            this.$setCurrentReservation(res);

            if (this.currentReservation.guests.length === 1) {
              if (this.paramsReady) {
                this.cardClick(
                  this.currentReservation.id,
                  this.currentReservation.guests[0].id
                );
              } else {
                this.hasOne = true;
              }
            } else if (this.currentReservation.guests.length === 0) {
              FlashMessageService.warning(
                this.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
              );
              this.$redirectSearch();
            }
          })
          .catch(() => {
            FlashMessageService.warning(
              this.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
            );
            this.$redirectSearch();
          });
      },
      toggleMenu: function() {
        this.isActive = !this.isActive;
      },
      getLogoUrl: function() {
        return this.customizationSettings.portalLogoUrl
          ? this.customizationSettings.portalLogoUrl + `?unique=${uuid.v4()}`
          : require("@/assets/images/logo-smart.png");
      }
    },
    mapActions(["$setCurrentReservation", "$setCurrentGuest"])
  )
};
